<template>
    <div>
        <div class="mainwrap">
            <keep-alive exclude="">
                <router-view class="router_contents" :key="$route.fullPath" :style="{ overflow: $route.path === '/view/agreement_contents' ? 'auto' : null }"></router-view>
            </keep-alive>
        </div>
        <div class="modaldiv">
            <transition-group :name="$GlobalStore.modalTransitionName()">
                <div v-for="each, index in $store.state.modals" class="each_modal" :key="each.view + index" :ref="'modalRef' + index" :style="{
                    backgroundColor: each.isModalBackTransparent ? 'transparent' : ''
                }">
                    <div class="bounce_back_cover" :ref="'modalRefBack' + index" :style="{ backgroundColor: each.isModalBackTransparent ? 'transparent' : '' }"></div>
                    <!--<div class="modal">-->
                    <component class="modal" :style="{ position: each.view === 'FindPositionProResult' ? '' : 'relative' }" :is="each.view" v-bind="each"></component>
                    <!--</div>-->

                </div>
            </transition-group>
        </div>
        <CommonConfirm v-if="$GlobalStore.isShowConfirm()"></CommonConfirm>
    </div>
</template>

<script>
import Survey from '@/components/modal/Survey';
import WagesAgreement from '@/components/modal/WagesAgreement'
import ContractAgreement from '@/components/modal/ContractAgreement'
import DaumAddress from '@/components/modal/DaumAddress';
import MemberRegister from '@/components/modal/MemberRegister';
import Contract from '@/components/modal/Contract';
import Login from '@/components/page/Login';
import Setting from '@/components/modal/Setting';
import {WAGES_AGREEMENT_MODE} from "./modal/WagesAgreement";
import {CONTRACT_AGREEMENT_MODE} from "./modal/ContractAgreement";
import CommonConfirm from '@/components/common/CommonConfirm'
import PushManager from '@/modules/PushManager'

export default {
    name: "PageFrame",
    components: {
        Survey, DaumAddress, WagesAgreement, ContractAgreement, MemberRegister, Setting, Login, CommonConfirm, Contract
    },
    data() {
        return {
            addPushDeviceCnt: 0,
        }
    },
    methods: {
        async getDefaultData() {
            const res = await this.$Axios.get('/api/default');
            if(res.data.loginInfo) this.$GlobalStore.setLoginInfo(res.data.loginInfo);
        },
        setPushToken(){
            // alert(this.$cookies.get("device"));
            const device = this.$cookies.get("device");
            const pushManager = PushManager(device, this.goAction);
            window.pushCustomManager = pushManager;

            if (this.$route.query.type != null) {
                pushManager.goScreen(this.$route.query.type, this.$route.query.param1, this.$route.query.param2, this.$route.query.param3, this.$route.query.param4);
            }

            if (device === 'ios' || device === 'android') {
                setTimeout(this.addPushDevice, 5000);
            }
        },
        //type title, param1 => refer_idx, param2 => action, param3 => param1, param4
        async goAction(type, param1, param2, param3, param4){
            console.log(param2, param3, param4);
            // alert('type : ' + type + ', param1 : ' + param1 + ', param2 : ' + param2+ ', param3 : ' + param3+ ', param4 : ' + param4)
            // if (param2 && param2 != '0') {
            //     switch (param2) {
            //         case '1': //용병
            //
            //     }
            // }
        },
        async addPushDevice() {
            const uuid = await window.pushCustomManager.getUuid();
            const token = await window.pushCustomManager.getPushToken();

            if ((token === '(null)' || token.length < 20) && this.addPushDeviceCnt < 6) {
                this.addPushDeviceCnt++;
                setTimeout(this.addPushDevice, 10000);
                return;
            }

            if (uuid !== "" && (!this.$hasOwnProperty(localStorage, 'uuid') || localStorage['uuid'] !== uuid || !this.$hasOwnProperty(localStorage, 'pushToken') || localStorage['pushToken'] !== token)) {
                var parameter = {};
                parameter.uuid = uuid;
                parameter.token = token;
                parameter.os = this.$cookies.get('device') === 'ios' ? 'iOS' : this.$cookies.get('device');
                var devName = await window.pushCustomManager.getDeviceName();
                if (devName) parameter.devName = devName;

                const res = await this.$Axios.post('/api/uuid', parameter);
                if (res.data.code === 0) {
                    localStorage.setItem('uuid', uuid);
                    localStorage.setItem('pushToken', token);
                } else if (res.data.code === -1) {
                    this.showAlert(res.data.msg);
                }
            }
        },
    },
    mounted() {
        this.setPushToken();
    },
    created() {
        if(location.pathname ===  '/view/agreement_wage_pop'){
            this.$GlobalStore.addModal('WagesAgreement', {transitionName : '', mode : WAGES_AGREEMENT_MODE.VIEW, is_show_back_btn: false});
        }else if(location.pathname === '/view/agreement_work_pop'){
            let mode = CONTRACT_AGREEMENT_MODE.INSERT;
            if(this.$route.query.view && this.$route.query.view == '1'){
                mode = CONTRACT_AGREEMENT_MODE.VIEW;
            }
            this.$GlobalStore.addModal('ContractAgreement', {transitionName : '', mode : mode, is_show_back_btn: false});
        }else {
            this.getDefaultData();
        }
    }
}
</script>

<style scoped>
.bounce_back_cover {
    position: fixed;
    left: 0px;
    top: 0px;
    bottom: 0px;
    width: 100vw;
    background-color: white;
    display: none;
}

.mainwrap {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.router_contents {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    left: 0%;
    background-color: white;
    overflow: hidden;
}

.each_modal {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100vw;
    background-color: white;
}

.modal {
    height: 100%;
    display: flex;
    flex-direction: column;
    /*background-color:rgb(241, 241, 241);*/
}

.right-enter-active,
.right-leave-active {
    transition: left .3s;
}

.right-enter,
.right-leave-to {
    left: 100%;
}

.bottom-enter-active,
.bottom-leave-active {
    transition: top .5s;
}

.bottom-enter,
.bottom-leave-to {
    top: 100%;
}

.fade-enter-active,
.fade-leave-active {
    transition: left .3s;
}

.fade-enter,
.fade-leave-to {
    left: -100%;
}

</style>
